<template>
  <div>
    <div class="primary--text font-weight-medium text-center">THUÊ XE</div>
    <v-simple-table fixed-header class="table-padding-2 table-h-36">
      <template v-slot:default>
        <tbody>
          <tr class="font-weight-medium black--text text-center">
            <td>Ngày thuê</td>
            <td>Giá ngày</td>
          </tr>
          <tr
            v-for="item in services"
            :key="`i_${item.id}`"
            class="text-center"
          >
            <td>
              {{ item.from_day }}
              →
              {{ item.to_day }}
            </td>
            <td>{{ formatNumber(item.price) }} VND</td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>

    <div class="primary--text font-weight-medium text-center mt-5">GIAO XE</div>
    <v-simple-table fixed-header class="table-padding-2 table-h-36">
      <template v-slot:default>
        <tbody>
          <tr class="font-weight-medium black--text text-center">
            <td>Khoảng cách</td>
            <td>Giá dịch vụ</td>
          </tr>
          <tr
            v-for="item in deliveryServices"
            :key="`i_${item.id}`"
            class="text-center"
          >
            <td>
              {{ item.from_km }}
              →
              {{ item.to_km }}
              Km
            </td>
            <td>{{ formatNumber(item.price) }} VND</td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>

    <ul class="fs-12 mt-5 purple--text font-italic">
      <li>
        Trong trường hợp gia hạn hợp đồng, nếu hợp đồng gốc hoặc các lần gia hạn
        trước đó chưa được tất toán, ngày thuê từ hợp đồng gốc và các lần gia
        hạn sẽ được cộng dồn để tính phí cho lần gia hạn kế tiếp.
      </li>
      <li>Trong mọi trường hợp, dịch vụ đã mua không được hoàn tiền.</li>
      <li>Bảng giá đã bao gồm VAT./.</li>
    </ul>
  </div>
</template>

<script>
import { httpClient } from "@/libs/http";

export default {
  name: "PriceContract",
  data: () => ({
    services: [],
    deliveryServices: [],
  }),
  computed: {},
  mounted() {
    this.getServices();
    this.getDeliveryServices();
  },
  methods: {
    async getServices() {
      const { me } = window;

      const { data } = await httpClient.post("/common/v1/get-service");
      this.services = [...data].filter(
        (s) =>
          s.id_account == me.id ||
          (s.id_account == -1 && s.id_city == me.id_city)
      );
    },
    async getDeliveryServices() {
      const { me } = window;

      const { data } = await httpClient.post("/common/v1/get-delivery-service");
      this.deliveryServices = [...data]
        .filter((s) => s.id_city == me.id_city)
        .map((s) => ({
          ...s,
          from_km: Math.floor(s.distance_from / 100) / 10,
          to_km: Math.floor(s.distance_to / 100) / 10,
        }));
    },
  },
};
</script>

<style scoped></style>
